import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full flex justify-center items-center" }
const _hoisted_3 = ["data-tip"]

import { ref, watch } from "vue";
import { KeyCode, NonKeycodeAction } from "@/keyboard";
import { useCaptureKeys } from "@/composables";
import ListSelect from "@/components/utils/ListSelect.vue";
import ActionList from "@/components/actions/ActionList.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionSubmenu',
  props: {
    keycodes: {},
    keycodeOptions: {},
    actions: {}
  },
  emits: ["newKeycodes", "newActions"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const keyCapture = ref<HTMLElement | null>(null);
const capturedKeycodes = useCaptureKeys(keyCapture);
const captureEnabled = ref(false);

watch(capturedKeycodes.value, () => {
  if (captureEnabled.value)
    emit("newKeycodes", Array.from(capturedKeycodes.value));
});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ListSelect, {
        multiple: "",
        class: "keycaps-select select-deselect-full w-full max-w-md mb-2 mr-2",
        clearable: false,
        placeholder: "Add keys",
        options: _ctx.keycodeOptions,
        modelValue: _ctx.keycodes,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (kc) => _ctx.$emit('newKeycodes', kc))
      }, null, 8, ["options", "modelValue"]),
      _createElementVNode("div", {
        class: _normalizeClass(["tooltip focus-within:tooltip-open transition-colors duration-200", captureEnabled.value ? 'tooltip-accent' : '']),
        "data-tip": 
          captureEnabled.value
            ? 'Now press desired keys on keyboard, click outside to finish'
            : 'Click to enter from keyboard'
        
      }, [
        _createElementVNode("div", {
          ref_key: "keyCapture",
          ref: keyCapture,
          tabindex: "-1",
          class: "px-2 btn btn-sm btn-ghost focus:bg-accent",
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (captureEnabled.value = true)),
          onBlur: _cache[2] || (_cache[2] = ($event: any) => (captureEnabled.value = false))
        }, [
          _createVNode(_component_Icon, { icon: "material-symbols:keyboard-alt-outline" })
        ], 544)
      ], 10, _hoisted_3)
    ]),
    _createVNode(ActionList, {
      modelValue: _ctx.actions,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = (a) => _ctx.$emit('newActions', a))
    }, null, 8, ["modelValue"])
  ]))
}
}

})